export const COMPLAINT_MARK_IMPORTANT = {
    REQUEST: 'COMPLAINT_SELLER.COMPLAINT_MARK_IMPORTANT.REQUEST',
    SUCCESS: 'COMPLAINT_SELLER.COMPLAINT_MARK_IMPORTANT.SUCCESS',
    FAILED: 'COMPLAINT_SELLER.COMPLAINT_MARK_IMPORTANT.FAILED',
    ERROR: 'COMPLAINT_SELLER.COMPLAINT_MARK_IMPORTANT.ERROR',
};

export const COMPLAINT_MARK_IMPORTANT_CLEAR = "COMPLAINT_MARK_IMPORTANT_CLEAR";